import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import address from './modules/address'
import order from './modules/order'
import robotQuote from './modules/robotQuote'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    address,
    order,
    robotQuote,
  }
})
